import isEqual from 'lodash.isequal'
import React, { memo } from 'react'

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M8 9.291h1.714V7.683c0-.708.02-1.802.553-2.479C10.829 4.487 11.6 4 12.927 4 15.089 4 16 4.297 16 4.297l-.429 2.451s-.714-.199-1.38-.199c-.667 0-1.264.23-1.264.873v1.87h2.733l-.19 2.392h-2.543V20H9.714v-8.316H8V9.291Z"
    />
  </svg>
)

const Facebook = memo(SvgComponent, isEqual)
export default Facebook
